import { Component, inject } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { NavigationEnd, Router, RouterOutlet } from '@angular/router';
import { isPublicPage, publicKindOfPath, publicKindOfSnapshot } from './shared/utils/public-route';
import { filter, map } from 'rxjs';

import { AmplitudeService } from './shared/services/amplitude.service';
import { AuthService } from './auth/services/auth.service';
import { NavbarComponent } from './shared/components/navbar/navbar.component'
import { BreadcrumbsComponent } from './shared/components/breadcrumbs/breadcrumbs.component';
import { DownloadPillComponent } from './shared/components/download-pill/download-pill.component';
import { TermsOfServiceService } from './shared/services/terms-of-service.service';

import { WhatsAppPromptCardComponent } from './shared/whatsapp/whatsapp-prompt-card.component'
import { WhatsNewCardComponent } from './shared/whats-new/whats-new-card.component'
@Component({
  selector: 'app-root',
  imports: [RouterOutlet, NavbarComponent, BreadcrumbsComponent, DownloadPillComponent, WhatsAppPromptCardComponent, WhatsNewCardComponent],
  templateUrl: './app.html',
})
export class App {
  protected title = 'Science of Sports';
  protected readonly authService = inject(AuthService);
  private readonly termsOfServiceService = inject(TermsOfServiceService);
  private readonly amplitudeService = inject(AmplitudeService);

  private readonly router = inject(Router);

  /** Pages that stand alone, even for someone signed in, say so in their route data (Release 5,
   *  31/10/2026, PUBLIC-02 -- shared/utils/public-route.ts): watch, files, offer, unlock, n,
   *  unsubscribe, join and welcome always; the live pages only for someone signed out, since a
   *  signed-in member keeps the top bar and the breadcrumbs as a way back (CC, 10/10/2026). */
  protected readonly publicPage = toSignal(
    this.router.events.pipe(
      filter((e): e is NavigationEnd => e instanceof NavigationEnd),
      map(() => isPublicPage(publicKindOfSnapshot(this.router.routerState.snapshot.root), this.authService.isAuthenticated())),
    ),
    { initialValue: isPublicPage(publicKindOfPath(window.location.pathname, this.router.config), this.authService.isAuthenticated()) },
  );

  constructor() {
    this.initializeAmplitude();
    this.initializeTermsOfService();
  }

  private initializeTermsOfService(): void {
    // A signed-in person opening a shared match is a viewer there, not a platform user.
    if (this.authService.isAuthenticated() && !this.publicPage()) {
      this.termsOfServiceService.checkTermsAcceptance();
    }
  }

  private initializeAmplitude(): void {
    this.amplitudeService.initialize();

    const user = this.authService.currentUser();
    if (!user?.id) {
      return;
    }

    this.amplitudeService.identify(user.id, {
      email: user.email,
      phoneNumber: user.phone_number,
      firstName: user.first_name,
      lastName: user.last_name,
      role: user.role,
    });
  }
}
